import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {
  Pipeline,
  SearchProvider,
  FieldDictionary,
  Variables,
  ClickTracking,
  FilterBuilder
} from "@sajari/react-search-ui";


const rootContainer = document.querySelector("#searchio-results");
const account = rootContainer.dataset.account;
const collection = rootContainer.dataset.collection;
const contentTypes = rootContainer.dataset.contentType === '' ? [] : rootContainer.dataset.contentType.split(',');
const kcTypes = ["Articles","Video","Publications","Inside RGA","Research and White Papers"];
let selectedTypes = "contenttype !='Solution'";

if (contentTypes.length >= 1) {
    selectedTypes = contentTypes.map(type => `contenttype='${type}'`).join(' OR ')
}

const isKC = kcTypes.some(r=> selectedTypes.includes(r)); // check if knowlege center types are selected
let additionalFields = isKC ? new Variables({"filter":`${selectedTypes}`,"sort":"-articledate"}) : new Variables({"filter":`${selectedTypes}`});

/** 
 * Pipeline Setup 
 * https://react.docs.search.io/classes/pipeline
**/
const pipeline = new Pipeline(
  {
    account,
    collection,
  },
  "website", 
  new ClickTracking(),
);

/** 
 * Fields for result items
 * https://react.docs.search.io/classes/fielddictionary 
**/
const fields = new FieldDictionary({
  title:'title',
  displaytitle: 'displaytitle',
  image: 'image',
  imagealt : "imagealt",
  description: 'description',
  contenttype: 'contenttype',
  categories: 'categories',
  articledate: 'articledate',
  ctalinktext: 'ctalinktext',
  ctapageurl: 'ctapageurl',
  ctalink: 'ctalink',
  contactlinktext: "contactlinktext",
  contactlink: "contactlink",
  contactpageurl: "contactpageurl",
  personcontacturl: "personcontacturl",
  personlinkedin: "personlinkedin",
  personbio: "personbio",
  firstname: "firstname",
  lastname:"lastname",
  companyinfo: "companyinfo"
});

/** 
    * Creating Necessary Filters 
    * https://react.docs.search.io/classes/filterbuilder
**/
const solutionAreasFilter = new FilterBuilder({
  name:'solutionareas',
  field:'solutionareas',
  array:true
});

const regionsFilter = new FilterBuilder({
  name:'region',
  field:'region',
  array:true
});

const contentTypeFilter = new FilterBuilder({
  name:'contenttype',
  field:'contenttype',
  array:false
});

const categoriesFilter = new FilterBuilder({
  name:'categories',
  field:'categories',
  array:true
});

const authorsFilter = new FilterBuilder({
  name:'authors',
  field:'authors',
  array:true
});

const yearFilter = new FilterBuilder({
  name:'publishyear',
  field:'publishyear',
  array:false
});

/** 
 * Custom Classes for Generated Elements 
 * Pass your selected content type to the getCustomClasses function to get the correct classes for the results
 * https://react.docs.search.io/styling
**/

const baseClasses = {
    filter: {
        box: 'filter',
        header: 'filter__header',
        title: "filter__title",
        resetButton: 'filter__reset',
        list: {
            container: "filter__list",
            checkboxGroup: "filter__list-group filter__list-group--checkbox",
            toggleButton: "filter__show-toggle"
        }
    },
    sorting: {
        container: "sorting__wrapper",
        label: "sorting__label",
        select: "sorting__select"
    },
    input: {
        input: "search-results__input-field",
        inputContainer: "search-results__input-icon"
    }
};

const getCustomClasses = (selectedType) => {
    const resultsClasses = {
        Solution: {
            template: {
                container: 'solutions',
                resultContainer: 'solutions__item'
            }
        },
        Person: {
            template: {
                container: 'people__list',
                resultContainer: 'people__item'
            }
        }
    };

    return {
        ...baseClasses,
        results: resultsClasses[selectedType]
    };
};

const customClasses = contentTypes.length >= 1 ? getCustomClasses(contentTypes[0]) : baseClasses;

const root = ReactDOM.createRoot(document.getElementById("searchio-results"));

root.render(
  <SearchProvider
    search={{
      pipeline,
      fields: fields,
      variables: additionalFields,
      filters: [solutionAreasFilter, regionsFilter,contentTypeFilter, categoriesFilter,authorsFilter,yearFilter],
    }}
    searchOnLoad 
    customClassNames={customClasses} 
    syncURLState={true} 
    theme={{
        color: {
            primary: {
                base:'#000000',
                active:'#c00'
            }
        }
    }}
    
  >
    
    <App gettype={rootContainer.dataset.contentType} selectedtype={selectedTypes} />
  </SearchProvider>
);
